<template>
  <div>
    <b-loading :is-full-page="true" :active.sync="isFetchingData" :can-cancel="false"></b-loading>
    <div class="level">
      <div class="level-left">
        <h5 class="title is-5">Your Monthly Profit</h5>
      </div>
      <div class="level-right">
        {{monthlyQuota.percentage}}
      </div>
    </div>
    <progress :class="progressBar" :value="monthlyQuota.totalProfit" :max="monthlyQuota.quota"></progress>
    <p>Weekly quota:
      <strong>{{monthlyQuota.quota}}</strong>
    </p>
    <p>Total profit:
      <strong>{{monthlyQuota.totalProfit}}</strong>
    </p>
  </div>
</template>

<script>
import AppProgress from '../../components/frontend/appProgress'
import axios from 'axios'

const appProgress = new AppProgress()

export default {
  props: ['year', 'month', 'isAdaptive'],
  created() {
    this.getMonthlyQuotaAndProfit()
  },
  data: () => ({
    progressBar: appProgress.isDefault(),
    monthlyQuota: {},
    isFetchingData: false
  }),
  watch: {
    year() {
      if (this.year) {
        this.getMonthlyQuotaAndProfit()
      }
    },
    month() {
      if (this.year) {
        this.getMonthlyQuotaAndProfit()
      }
    },
    isAdaptive() {
      this.getMonthlyQuotaAndProfit()
    }
  },
  methods: {
    getMonthlyQuotaAndProfit() {
      this.monthlyQuota.percentage = '...'
      this.isFetchingData = true
      axios
        .get(
          `api/dashboard/monthly-total-profit-by-year/${this.isAdaptive}/${
            this.year
          }/${this.month}`
        )
        .then(response => {
          this.monthlyQuota = response.data

          const monthlyQuotaPercentage = this.monthlyQuota.percentage
          if (monthlyQuotaPercentage <= 25) {
            this.progressBar = appProgress.isDanger(true)
          }

          if (monthlyQuotaPercentage <= 50 && monthlyQuotaPercentage > 26) {
            this.progressBar = appProgress.isWarning(true)
          }

          if (monthlyQuotaPercentage <= 75 && monthlyQuotaPercentage > 51) {
            this.progressBar = appProgress.isInfo(true)
          }

          if (monthlyQuotaPercentage <= 99 > monthlyQuotaPercentage > 76) {
            this.progressBar = appProgress.isLink(true)
          }

          if (monthlyQuotaPercentage > 100) {
            this.progressBar = appProgress.isSuccess(true)
          }

          this.monthlyQuota.percentage = `${this.monthlyQuota.percentage}%`
          this.isFetchingData = false
        })
        .catch(error => {
          console.log(error)
          this.monthlyQuota = {}
          this.progressBar = appProgress.isDefault()
        })
        .then(() => (this.isFetchingData = false))
    }
  }
}
</script>
